import omit from 'lodash/omit';
import { SkillType } from '../graphql/types';
import type { FilterValues } from '../hooks/useFilters';

const OMMITTED_BY_SKILL_TYPE: Record<SkillType, (keyof FilterValues)[]> = {
  [SkillType.indemand]: ['job_id'],
  [SkillType.most_targeted]: ['job_id', 'org_id', 'skill_ids'],
  [SkillType.top_skills]: ['job_id', 'org_id', 'skill_ids'],
  [SkillType.job_skills]: ['org_id', 'skill_ids']
};

export const omitParamsBySkillType = <T extends FilterValues>(params: T, skillType: SkillType) => ({
  ...omit(params, OMMITTED_BY_SKILL_TYPE[skillType]),
  skill_type: skillType
}) as T & { skill_type: SkillType; };
